module.exports = __webpack_public_path__ + "static/media/logo_sharedimobihyb.ca88be65.png";